import { useState } from 'react';
import './ToolStyles.css';

const JsonFormatter = () => {
    const [input, setInput] = useState('');
    const [output, setOutput] = useState('');
    const [error, setError] = useState('');
    const [mode, setMode] = useState<'format' | 'compress'>('format');

    const formatJson = (jsonStr: string): string => {
        try {
            const parsed = JSON.parse(jsonStr);
            return JSON.stringify(parsed, null, 2);
        } catch (err) {
            throw new Error('JSON格式错误');
        }
    };

    const compressJson = (jsonStr: string): string => {
        try {
            const parsed = JSON.parse(jsonStr);
            return JSON.stringify(parsed);
        } catch (err) {
            throw new Error('JSON格式错误');
        }
    };

    const handleProcess = () => {
        setError('');

        if (!input.trim()) {
            setError('请输入JSON字符串');
            return;
        }

        try {
            const result = mode === 'format' ? formatJson(input) : compressJson(input);
            setOutput(result);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'JSON处理失败');
            setOutput('');
        }
    };

    const handleCopy = async () => {
        if (!output) return;

        try {
            await navigator.clipboard.writeText(output);
            alert('已复制到剪贴板');
        } catch (err) {
            alert('复制失败');
        }
    };

    const handleClear = () => {
        setInput('');
        setOutput('');
        setError('');
    };

    return (
        <div className="tool-container">
            <div className="button-group">
                <button
                    className={`mode-button ${mode === 'format' ? 'active' : ''}`}
                    onClick={() => setMode('format')}
                >
                    格式化
                </button>
                <button
                    className={`mode-button ${mode === 'compress' ? 'active' : ''}`}
                    onClick={() => setMode('compress')}
                >
                    压缩
                </button>
            </div>

            <div className="input-group">
                <label className="input-label">输入JSON</label>
                <textarea
                    className="tool-textarea"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder='{"name": "example", "value": 123}'
                    rows={10}
                />
            </div>

            {error && <div className="error-message">{error}</div>}

            <div className="button-group">
                <button className="tool-button primary" onClick={handleProcess}>
                    {mode === 'format' ? '格式化' : '压缩'}
                </button>
                <button className="tool-button" onClick={handleClear}>
                    清空
                </button>
            </div>

            {output && (
                <div className="output-group">
                    <div className="output-header">
                        <label className="output-label">输出结果</label>
                        <button className="copy-button" onClick={handleCopy}>
                            📋 复制
                        </button>
                    </div>
                    <pre className="tool-output code">{output}</pre>
                </div>
            )}

            <div className="info-box">
                <h4>功能说明：</h4>
                <ul>
                    <li>格式化：将压缩的JSON转换为易读格式</li>
                    <li>压缩：移除所有空格和换行</li>
                    <li>自动检测JSON语法错误</li>
                    <li>支持一键复制到剪贴板</li>
                </ul>
            </div>
        </div>
    );
};

export default JsonFormatter;
